/**
 * Utility helpers for the Case Summary tab components.
 */

/**
 * Parses a string value that may be a JSON array or comma-separated into an array of strings.
 *
 * @param value - Raw string value from the data model
 * @returns Parsed array of strings, or empty array if null/empty
 */
export const parseListField = (value: string | null | undefined): string[] => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed;
  } catch {
    // Fall back to comma-separated split
  }
  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

/**
 * Returns the appropriate background and text color classes for a confidence badge.
 *
 * @param confidence - Confidence level string (e.g. "High", "Medium", "Low")
 * @returns Object with bg and text Tailwind classes
 */
export const getConfidenceBadgeColors = (confidence: string) => {
  const level = confidence.toLowerCase();
  if (level === "high") return { bg: "bg-[#E6F3F0]", text: "text-[#005D49]" };
  if (level === "medium") return { bg: "bg-[#FFF3E0]", text: "text-[#E65100]" };
  return { bg: "bg-[#FAE6E6]", text: "text-[#BB0202]" };
};
